
import commonImg from '~/components/common/commonImg.vue'
export default {
  components: {
    'common-img': commonImg
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    labelshow: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
  }
}
